/// <reference path="../bower_components/jquery/dist/jquery.js" />
function setSelectedCountMessage() {
    $('#soldListingsSelected span').text("Properties you want to display: " + $('#listingsSelected .sold-listing').length + " of 30");
}

function showHideSoldListings() {
    var $this = $("input[type='radio'][name='overrideOption']:checked");
    if ($this.val() === 'true') {
        $('.select-listings').removeClass('hide');
        $('#overrideSoldListings').val(true);
    } else {
        $('.select-listings').addClass('hide');
        $('#overrideSoldListings').val(false);
    }
}

function animateWatchlist() {
    $('#open-watchlist-message a').animateCss('pulse longer active');
}

function animateSavedSearch() {
    $('#open-saved-searches-message a').animateCss('pulse longer active');
}

function removeSavedSearch(el) {
    $.post('/save-search/remove', {
            "": el.data('savedsearchid')
        })
        .done(function() {
            el.parents('div.savedSearch').remove();
            if ($('div.savedSearch').length === 0) {
                $('#noSavedSearches').show();
            }
        });
}

function saveAlertPreference(el) {
    $.post('/save-search/save-alert-preference', {
        SavedSearchId: el.data('savedsearchid'),
        AlertFrequency: el.val()
    });
}

function saveSearch() {
    $.post('/save-search', {
            SearchUrl: window.location.href,
            SearchLocation: $('#searchLocation').text()
        })
        .done(function() {
            $('.saveSearch').html('<svg class="svg svg-icon-check"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-check"></use></svg> Search saved').removeClass('btn-default').addClass('btn-info');
            $('.saveSearch').find('.svg').animateCss('swing');
            var savedSearchAlert = Cookies.getJSON('savedSearchAlert');
            if (savedSearchAlert !== 1) {
                showHideSidebarToggle();
                swal({
                    title: 'Search saved',
                    text: 'Your saved searches can be accessed anytime through <span class="hidden-xs">clicking</span><span class="visible-xs-inline">touching</span> the "Your Bayleys" button',
                    confirmButtonText: 'Ok',
                    confirmButtonClass: 'btn-info btn-outline',
                    type: 'success',
                    timer: 20000,
                    html: true
                });
                animateSavedSearch();
            }
            $('#sidebar-tabs a[href="#watchlist-tab"]').tab('show');
            Cookies.set('savedSearchAlert', '1', { expires: 7 });
        });
}

function addToWatchList(el) {
    $.post('/watch-list/add', {
            ListingId: el.data('listingid')
        })
        .done(function (watchListResult) {
            if (!watchListResult.TooMany) {
                el.html('<svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> In your watchlist');
                el.addClass('btn-danger saved active');
                el.find('.svg').animateCss('swing');
                el.removeClass('btn-info');
                el.data('watchlistitemid', watchListResult.WatchListItemId);
                var watchlistAlert = Cookies.getJSON('watchlistAlert');
                if (watchlistAlert !== 1) {
                    showHideSidebarToggle();
                    swal({
                        title: 'Added to watchlist',
                        text: 'Your watchlist can be accessed anytime through <span class="hidden-xs">clicking</span><span class="visible-xs-inline">touching</span> the "Your Bayleys" button',
                        confirmButtonText: 'Ok',
                        confirmButtonClass: 'btn-info btn-outline',
                        type: 'success',
                        timer: 20000,
                        html: true
                    },
                        function (isConfirm) {
                            showHideSidebarToggle();
                        });
                    animateWatchlist();
                }
                $('.right-sidebar-toggle .svg-icon-heart').removeClass('hide').animateCss('rollIn');
                $('.right-sidebar-toggle-bottom .svg-icon-heart').removeClass('hide').animateCss('rollIn');
                $('#sidebar-tabs a[href="#watchlist-tab"]').tab('show');
                Cookies.set('watchlistAlert', '1', { expires: 7 });
            } else {
                swal({
                    title: 'Watchist too large',
                    text: 'Please prune your watchlist to less than 100 items by click Go to Watchlist.',
                    showCancelButton: true,
                    cancelButtonText: 'Go to Watchlist',
                    cancelButtonClass: 'btn-info btn-outline',
                    confirmButtonText: 'Cancel',
                    confirmButtonClass: 'btn-info btn-outline',
                    reverseButtons: false,
                    type: 'error',
                    timer: 20000,
                    html: true
                },
                    function (isConfirm) {
                        if (!isConfirm) {
                            location.href = '/my-bayleys/my-watch-list';
                        }
                    });
            }
        });
}

function deleteFromWatchListButton(el) {
    $.post('/watch-list/delete', {
            WatchListItemId: el.data('watchlistitemid')
        })
        .done(function() {
            el.html('<svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> Add to watchlist');
            el.addClass('btn-info');
            el.removeClass('btn-danger saved active');
            el.data('watchlistitemid', '');
            el.find('.svg').animateCss('swing');
        });
}

function deleteFromWatchList(el) {
    $.post('/watch-list/delete', {
            WatchListItemId: el.data('watchlistitemid')
        })
        .done(function() {
            el.parents('.listing').parent('.col-xs-12').remove();
            if ($('.listing').length === 0) {
                $('#noWatchListItems').removeClass('hide');
                $('#watchSharePrint').addClass('hide');
            }
        });
}

function initializeMyBayleys() {
    if ($('#myBayleysContent').length > 0) {
        $('#soldListingSearch').click(function() {
            if ($('#soldListingIdSearch').val().length > 0) {
                $('.sold-listing').hide();
                $('.sold-listing[data-listingid="' + $('#soldListingIdSearch').val() + '"]').show();
            } else {
                $('.sold-listing').show();
            }
        });
        $("input[type='radio'][name='overrideOption']").click(function() {
            showHideSoldListings();
        });
        $('#saveButton').click(function() {
            $('#frmOverrideListings').submit();
        });
        showHideSoldListings();
        if ($('#listingsSold').length > 0) {
            dragula([document.getElementById("listingsSold"), document.getElementById("listingsSelected")], {
                    accepts: function(el, target, source, sibling) {
                        if ($('#listingsSelected .sold-listing').length > 30) {
                            return false;
                        }
                        return true;
                    },
                    invalid: function(el, target) {
                        return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'LABEL';
                    },
                    revertOnSpill: true
                })
                .on('drop', function(el) {
                    setSelectedCountMessage();
                });
            setSelectedCountMessage();
        }
        $('div.savedSearch a.remove').click(function() {
            $('.saved-search-back').show();
        });
        $('div.saved-search-back a.button.confirm').click(function() {
            removeSavedSearch($(this));
        });
        $('div.saved-search-back a.button.cancel').click(function() {
            $(this).parents('div.saved-search-back').hide();
        });
        $('#watchList a.remove-from-watch-list').click(function() {
            $(this).parents('.listing').find('div.watch-list-item-back').show();
        });
        $('div.watch-list-item-back a.button.confirm').click(function() {
            deleteFromWatchList($(this));
        });
        $('div.watch-list-item-back a.button.cancel').click(function() {
            $(this).parents('div.watch-list-item-back').hide();
        });
        $('div.savedSearch .edit_text').editable(function(value, settings) {
            $.ajax('/save-search/save-name', {
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify({ SavedSearchId: $(this).data('savedsearchid'), SearchName: value })
            });
            return value;
        }, {
            type: 'text',
            tooltip: 'Click here to name your search',
            placeholder: 'Name your search',
            submit: 'OK',
            width: 305
        });
        // alert setting hookup
        $('div.savedSearch .saved-search-alert').change(function() {
            saveAlertPreference($(this));
        });
        if ($('.listing').length === 0) {
            $('#noWatchListItems').removeClass('hide');
            $('#watchSharePrint').addClass('hide');
        }
    }
}
